export default __webpack_public_path__ + "static/media/feature1.ad0b42ea.jpeg";